import React from "react";

// 4px gradient band between sections, fades toward edges.
// color: "gold" | "sage" | "rose" | "berry"
export default function SectionDivider({ color = "gold", bg = "#FAFAF8" }) {
    return (
        <div style={{ background: bg }} aria-hidden>
            <div className={`section-divider section-divider-${color}`} />
        </div>
    );
}
